import React from 'react';

import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';
import { Image } from '@/components/Image';
import ActionList from '@/components/LegacyMediaContainer/ActionList';
import { caption } from '@/components/LegacyMediaContainer/style';
import { MediaDisplay, MediasProps } from '@/components/LegacyMediaContainer/types';
import { isImage, isVideo } from '@/components/LegacyMediaContainer/utils';
import { EntityMediaFragment } from '@/features/messages/graphql/fragments/generated/MediaType';
import { MediaKindEnum } from '@/types/schema';

import { imageStyles } from '../../styles';

const ListRender: React.FC<{
  media: EntityMediaFragment;
  videoClassName?: string;
  imageClassName?: string;
}> = ({ media, videoClassName, imageClassName }) => {
  if (isVideo(media)) {
    return (
      <video
        controls
        playsInline
        className={cn('w-full rounded-8 object-contain', videoClassName)}
        src={media.url!}
      />
    );
  }

  if (isImage(media)) {
    return (
      <Image
        alt={media.name}
        className={cn('w-full rounded-8', imageStyles, imageClassName)}
        layout="fill"
        objectFit="contain"
        src={media.url!}
      />
    );
  }

  return null;
};

function ImageVideoPreview({
  actions,
  className,
  imageClassName,
  media,
  videoClassName,
  onAction,
}: Pick<
  MediasProps,
  'actions' | 'className' | 'imageClassName' | 'media' | 'videoClassName' | 'onAction'
>) {
  const { name, kind } = media;

  return (
    <Box className={cn('group relative w-full', className)}>
      <ListRender imageClassName={imageClassName} media={media} videoClassName={videoClassName} />
      <Box
        className={cn(
          'absolute bottom-0 hidden h-40 w-full rounded-b-4 pt-12 ps-20',
          { 'group-hover:block': kind !== MediaKindEnum.Video },
          caption,
        )}>
        <Typography color="text-text-white" variant="body-short-03">
          {name}
        </Typography>
      </Box>
      <ActionList
        actions={actions}
        displayMode={MediaDisplay.LIST}
        media={media}
        onAction={onAction}
      />
    </Box>
  );
}

export default ImageVideoPreview;
